import { render } from "./MyPageReport.vue?vue&type=template&id=63f3f766"
import script from "./MyPageReport.vue?vue&type=script&lang=js"
export * from "./MyPageReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__